"use client";

import React from "react";

type Props = {
  inlineEnabled: boolean;
  inlineAlign: "left" | "right";
  onToggleInline: (enabled: boolean, align?: "left" | "right") => void;
  labels: {
    inlineLabel: string;
    inlineLeft: string;
    inlineRight: string;
  };
};

export function BlockCardInlineControls({
  inlineEnabled,
  inlineAlign,
  onToggleInline,
  labels,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm text-gray-600">
      <label className="inline-flex items-center gap-2">
        <input
          type="checkbox"
          className="h-4 w-4"
          checked={inlineEnabled}
          onChange={(event) => onToggleInline(event.target.checked, inlineAlign)}
        />
        <span>{labels.inlineLabel}</span>
      </label>
      {inlineEnabled ? (
        <select
          className="rounded border border-gray-300 bg-white px-2 py-1 text-sm"
          value={inlineAlign}
          onChange={(event) => onToggleInline(true, event.target.value as "left" | "right")}
        >
          <option value="left">{labels.inlineLeft}</option>
          <option value="right">{labels.inlineRight}</option>
        </select>
      ) : null}
    </div>
  );
}

